(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairApprovedController', PhysicalFairApprovedController)

        PhysicalFairApprovedController.$inject = ['$uibModal', '$filter', 'SellerService' ,'ExpoService', 'VirtualFairService', 'AclService', 'toastr', '$timeout','AuthService'];


    function PhysicalFairApprovedController($uibModal, $filter, SellerService, ExpoService, VirtualFairService, AclService, toastr, $timeout, AuthService) {
        var vm = this;


        vm.approvedList             = '';
        vm.queryFlag                = false;
        vm.expo                     = '';
        vm.expoSelected             = '';
        vm.seller                   = '';
        vm.sellerSelected           = '';

        vm.countResult              = 0;
        vm.countUniversity          = 0;
        vm.countAgent               = 0;
        vm.countGovernment          = 0;
        vm.countOther               = 0;
        vm.boothInfoCheckSelected   = -1;
        vm.boothInfoSelected        = [];
        vm.selectExpo               = selectExpo;
        vm.getByFilter              = getByFilter;
        vm.getSellers               = getSellers;
        vm.openInfoModal            = openInfoModal;
        vm.checkCourseStatus        = checkCourseStatus;
        vm.checkApprovedPrograms    = checkApprovedPrograms;
        vm.downloadCSV              = downloadCSV;
        vm.downloadBannerUrlCSV     = downloadBannerUrlCSV;
        vm.hubLogin                 = hubLogin;
        vm.syncBooth                = syncBooth;
        vm.canSync                  = false;

        vm.boothInfoOptions = [
            {id: 'representatives', name: 'Representatives'},
            {id: 'videos', name: 'Videos'},
            {id: 'albums', name: 'Album'},
            {id: 'brochures', name: 'Brochures'},
            {id: 'branches', name: 'Branches'},
        ];
        vm.boothInfoCheckOptions   = [
            {id: -1, name: 'No'},
            {id: 1, name: 'Yes, with selected information'},
            {id: 0, name: 'Yes, without information'}
        ];

        function activate() {
            vm.selectExpo();
            vm.getSellers();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expos = response.data;
            }).catch(function(err) {

            });
        }

        function getSellers() {
            SellerService.getAll().then(function(response){
                vm.seller    = response.data;
                vm.seller.unshift({id:0,name:"All"});

            }).catch(function(err) {

            });
        }

        function openInfoModal(ApprovedItem, type) {
            var template = '';
            var items    = '';
            let filter = {};
            filter['id'] = ApprovedItem.id;
            if(type == 'albums') {
                template = 'templates/physicalfairs/approved/info/album_template.modal.html';
                ExpoService.getAlbums(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedPhysicalFairController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'albums';
                            },
                            setMaxRepresentatives: function () {
                                return true;
                            }
                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'videos'){
                template = 'templates/physicalfairs/approved/info/video_template.modal.html';
                ExpoService.getVideos(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedPhysicalFairController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'videos';
                            },
                            setMaxRepresentatives: function () {
                                return true;
                            }

                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'brochures'){
                template = 'templates/physicalfairs/approved/info/brochure_template.modal.html';
                ExpoService.getBrochures(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedPhysicalFairController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type: function () {
                                return 'brochures';
                            },
                            setMaxRepresentatives: function () {
                                return true;
                            }
                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'representatives'){
                template = 'templates/physicalfairs/approved/info/representative_template.modal.html';
                console.log(ApprovedItem.locations)
                    items = ApprovedItem.locations;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedPhysicalFairController',
                        controllerAs:'vm',
                        size: 'lg',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'representatives';
                            },
                            setMaxRepresentatives: function () {
                                return true;
                            }

                        }
                    });
            }

            if(type == 'program_types') {
                template = 'templates/physicalfairs/approved/info/program_types.modal.html';
                $uibModal.open({
                    templateUrl: template,
                    controller: 'InfoModalApprovedPhysicalFairController',
                    controllerAs:'vm',
                    resolve:
                    {
                        ApprovedItem      : function () {
                            return ApprovedItem.programs;
                        },
                        expoUserVirtualFairID : function () {
                            return ApprovedItem.id
                        },
                        item: function () {
                            return ApprovedItem
                        },
                        type: function () {
                            return 'programs';
                        },
                        setMaxRepresentatives: function () {
                            return true;
                        }
                    }
                });
            }

            if(type == 'branches') {
                template = 'templates/physicalfairs/approved/info/branches.modal.html';
                $uibModal.open({
                    templateUrl: template,
                    controller: 'InfoModalApprovedPhysicalFairController',
                    controllerAs:'vm',
                    resolve:
                    {
                        ApprovedItem: function () {
                            return ApprovedItem;
                        },
                        expoUserVirtualFairID : function () {
                            return ApprovedItem.id
                        },
                        item: function () {
                            return ApprovedItem
                        },
                        type: function () {
                            return 'branches';
                        },
                        setMaxRepresentatives: function () {
                            return true;
                        }
                    }
                });
            }
        }

        function getByFilter() {
            vm.query = {};

            if(typeof vm.sellerSelected !== 'undefined' &&  vm.sellerSelected.name !== 'All') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            if(vm.boothInfoCheckSelected != -1) {
                vm.query['booth_info_check'] = vm.boothInfoCheckSelected;
                if(vm.boothInfoSelected.length) {
                    vm.query['booth_info'] = JSON.stringify(vm.boothInfoSelected);
                }
            }

            ExpoService.getByFilterApproved(vm.query).then(function(response){
                vm.approvedList    = response.data.data;
                vm.queryFlag       = true;
                vm.countUniversity = response.data.countType[0].university;
                vm.countAgent      = response.data.countType[0].agent;
                vm.countGovernment = response.data.countType[0].government;
                vm.countOther      = response.data.countType[0].other;
                vm.countResult     = Object.keys(response.data.data).length;
                vm.checkApprovedPrograms();

            }).catch(function(err) {
            });
        }

        function checkApprovedPrograms() {
            angular.forEach(vm.approvedList, function(approved) {
                approved.programTypesPending = true;
                approved.programTypesProgramPending = false;
                approved.hasProgramTypes = true;

                if (approved.programs.length > 0) {
                    approved.programTypesPending = false;

                    angular.forEach(approved.programs, function(program) {
                        if (program.alias != 'mba' && program.alias != 'boarding') {
                            if (approved.programTypesProgramPending != true) {
                                if (program.total_areas == 0) {
                                    approved.programTypesProgramPending = true;
                                }
                            }

                        } else {
                            program.total_areas = false;
                        }
                    });
                }

            });
        }

        // function checkApprovedPrograms() {
        //     angular.forEach(vm.approvedList, function(approved) {
        //         vm.checkCourseStatus(approved);
        //     });
        // }

        function checkCourseStatus(approved) {
            approved.programTypesPending = false;
            approved.programTypesProgramPending = false;
            approved.hasProgramTypes = false;
            approved.hasType = {
                language : {
                    hasCourse: false,
                    isPending: false,
                },
                university : {
                    hasCourse: false,
                    isPending: false,
                },
                extension : {
                    hasCourse: false,
                    isPending: false,
                },
                graduate : {
                    hasCourse: false,
                    isPending: false,
                },
                online : {
                    hasCourse: false,
                    isPending: false,
                },
                vocational : {
                    hasCourse: false,
                    isPending: false,
                },
                mba : {
                    hasCourse: false,
                    isPending: false,
                },
                boarding : {
                    hasCourse: false,
                    isPending: false,
                },
            };

            if(approved.hasOwnProperty('profile') && approved.profile.profile_types != 'undefined') {
                angular.forEach(approved.profile.profile_types, function(value) {
                    if(approved.type == 'university' || approved.type == 'agent') {
                        approved.hasProgramTypes = true;
                        if (!approved.profile.profile_types || approved.profile.profile_types.length == 0) {
                            approved.programTypesPending = true;
                        }
                        if(value.profile_type.alias == 'language') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.language_program_languages_taught.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'university') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.university_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'extension') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if(approved.profile.extension_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'graduate') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.graduate_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'online') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.online_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if(value.profile_type.alias == 'vocational') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if(approved.profile.vocational_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if(value.profile_type.alias == 'mba') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                        } else if(value.profile_type.alias == 'boarding') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                        }
                    }
                });
            }
        }

        function syncBooth(virtual_fair_id, platform_fair_id, expo_virtual_fair_user_id) {

            VirtualFairService.platformSyncExec(
                virtual_fair_id,
                platform_fair_id,
                'exhibitors',
                expo_virtual_fair_user_id
            ).then(function(response){
                if (response.data.error) {
                    toastr.error('Sorry! There was an error.');
                } else {
                    toastr.success('The booth was successfully synchronized!');
                }
            });

        }

        function downloadCSV() {
            vm.query = {};

            if(typeof vm.sellerSelected !== 'undefined' &&  vm.sellerSelected.name !== 'All') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            if(vm.boothInfoCheckSelected != -1) {
                vm.query['booth_info_check'] = vm.boothInfoCheckSelected;
                if(vm.boothInfoSelected.length) {
                    vm.query['booth_info'] = JSON.stringify(vm.boothInfoSelected);
                }
            }
            ExpoService.getByFilterApprovedCSV(vm.query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `physical_fair_approved_${vm.expoSelected.id}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }

        function downloadBannerUrlCSV() {
            vm.query = {};

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }
            vm.query['banner'] = true;

            ExpoService.getByFilterApprovedCSV(vm.query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `banners_urls_${vm.expoSelected.id}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }

        function hubLogin(item, resource) {
            let data = {}
            data['physical_fair_id'] = item.expo_id;
            data['resource'] = resource;
            data['email'] = item.user.email;
            data['token'] = item.user.token;
            AuthService.loginNewHub(data).then(function (data) {
                console.log(data)
                var anchor = document.createElement("a");
                if(data.data.region === 'eu') {
                    anchor.href = `${data.data.url}${data.data.token}?physical_fair_id=${item.expo_id}`;
                    
                } else {
                    anchor.href = `${data.data.url}${data.data.token}`;
                }
                console.log(anchor.href);
                anchor.target = "_blank";
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
                
            });
        }
        // function hubLogin(item) {
        //     ExpoService.getHubLoginUrl(item.user.email, item.user.token, item.expo_id).success(function (data) {
        //         var anchor = document.createElement("a");
        //         anchor.href = data;
        //         anchor.target = "_blank";
        //         document.body.appendChild(anchor);
        //         anchor.click();
        //         $timeout(function () {
        //             anchor.remove();
        //         }, 50);
        //     });
        // }

        
        activate();
    }

})();
